(function () {
  'use strict';

  // ===========================
  // Root
  // ===========================
  const root = document.querySelector('.bundle-builder');
  if (!root) return;

  // ===========================
  // Responsive flag (optional)
  // ===========================
  function applyMobileFlag() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    root.classList.toggle('pfk-is-mobile', isMobile);
  }
  applyMobileFlag();
  window.addEventListener('resize', applyMobileFlag);

  // ===========================
  // Stable config (NO Liquid in JS)
  // ===========================
  const required = parseInt(root.dataset.required || '0', 10);
  const variantId = Number(root.dataset.variantId || 0);
  const basePrice = Number(root.dataset.basePrice || 0); // display only
  const baseCents = Number(root.dataset.baseCents || 0); // display only
  let sellingPlanId = root.dataset.sellingPlanId ? String(root.dataset.sellingPlanId) : '';

  const subPriceOverride = Number(root.dataset.subPriceOverride || 0);
  let SUB_PERCENT_OFF = Number(root.dataset.subPercentOff || 0);

  // Fallback: read from product JSON
  if (!sellingPlanId) {
    try {
      const jsonEl = document.querySelector('.pfk-product-json');
      const p = jsonEl ? JSON.parse(jsonEl.textContent || '{}') : {};
      const spg = p.selling_plan_groups || [];

      const firstPlan =
        spg[0] && spg[0].selling_plans && spg[0].selling_plans[0]
          ? spg[0].selling_plans[0]
          : null;

      if (firstPlan && firstPlan.id) {
        sellingPlanId = String(firstPlan.id);
        root.dataset.sellingPlanId = sellingPlanId;
      }

      const pa0 =
        firstPlan &&
        firstPlan.price_adjustments &&
        firstPlan.price_adjustments[0]
          ? firstPlan.price_adjustments[0]
          : null;

      if (pa0 && pa0.value_type === 'percentage' && pa0.value != null) {
        SUB_PERCENT_OFF = Number(pa0.value) || 0;
        root.dataset.subPercentOff = String(SUB_PERCENT_OFF);
      }
    } catch (e) {}
  }

  const isTouch =
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);


  let suppressGhostClickUntil = 0;

function suppressNextGhostClick(ms = 350) {
  suppressGhostClickUntil = Date.now() + ms;
}

function shouldSuppressGhostClick() {
  return Date.now() < suppressGhostClickUntil;
}

['click', 'touchstart', 'pointerdown'].forEach((evtName) => {
  document.addEventListener(evtName, (e) => {
    if (!isMobile()) return;
    if (!shouldSuppressGhostClick()) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
  }, true);
});

  // ===========================
  // DOM
  // ===========================
  const selectedCountEl = root.querySelector('.js-selected-count');
  const remainingTextEl = root.querySelector('.js-remaining-text');

  const addBtn = root.querySelector('.js-add-to-cart');
  const clearBtns = Array.from(root.querySelectorAll('.js-clear'));
  const msgEl = root.querySelector('.js-msg');

  const sumSelectedEl = root.querySelector('.js-sum-selected');
  const sumRemainingEls = Array.from(root.querySelectorAll('.js-sum-remaining'));
  const sumAddonsEl = root.querySelector('.js-sum-addons');
  const sumTotalEl = root.querySelector('.js-sum-total');
  const sumCtaBtn = root.querySelector('.js-summary-cta');
  const sumNoteEl = root.querySelector('.js-sum-note');
  const sumHelperEl = root.querySelector('.js-sum-helper');
  const addonsTotalTitleEl = root.querySelector('.js-addons-total');

  const priceOneEl = root.querySelector('.js-price-one');
  const priceSubEl = root.querySelector('.js-price-sub');
  const priceBadgeEl = root.querySelector('.js-price-badge');

  const cards = Array.from(root.querySelectorAll('.meal-card'));

  const sumWrap = document.getElementById('bundle-summary');
  const sumTitle = sumWrap ? sumWrap.querySelector('.summary-title') : null;
  const sumToggleBtn = sumWrap ? sumWrap.querySelector('.pfk-sum-toggle') : null;

  // ===========================
  // Purchase toggle
  // ===========================
  const purchaseRadios = Array.from(root.querySelectorAll('input[name="pfk_purchase"]'));
  const getPurchaseMode = () => (purchaseRadios.find(r => r.checked)?.value || 'one');
  const isSubscriptionSelected = () => {
    if (!sellingPlanId) return false;
    return getPurchaseMode() === 'sub';
  };

    function handlePurchaseModeChange() {
    updatePriceUI();
    updateAddonPriceUI();
    scheduleStatus();
  }

  purchaseRadios.forEach((radio) => {
    radio.addEventListener('change', handlePurchaseModeChange);
  });

  // ===========================
  // Money helpers
  // ===========================
  function moneyFromCents(cents) {
    const v = Number(cents || 0) / 100;
    return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function applyPercentOffCents(cents, percentOff) {
    const c = Number(cents || 0);
    const p = Number(percentOff || 0);
    return Math.round(c * (100 - p) / 100);
  }

  function getAddonPriceCents(row) {
    const c = row.dataset.priceCents;
    if (c != null && c !== '') return Number(c) || 0;
    const dollars = Number(row.dataset.price || 0);
    return Math.round(dollars * 100);
  }

  // ===========================
  // Mobile-stable tap handling
  // ===========================
  function bindTap(el, handler) {
    if (!el) return;
    if (el.dataset.pfkBound === '1') return;
    el.dataset.pfkBound = '1';

    el.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handler(e);
    }, { passive: false });
  }

  // ===========================
  // State
  // ===========================
  const state = {};
  const addonState = {};
  const isSelectionPage = window.location.pathname.indexOf('/pages/select-meals') !== -1;
  function getSelectionCycleKey() {
  if (!isSelectionPage) return 'default';

  try {
    const d = window.PFKDelivery.getNextDeliveryDate();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  } catch (e) {
    return 'default';
  }
}

function getSelectionStorageKey() {
  return `pfk_select_meals_state_v2_${getSelectionCycleKey()}`;
}

function getSelectionSubmittedKey() {
  return `pfk_select_meals_submitted_v2_${getSelectionCycleKey()}`;
}

function cleanupOldSelectionStorage() {
  if (!isSelectionPage) return;

  try {
    const currentStateKey = getSelectionStorageKey();
    const currentSubmittedKey = getSelectionSubmittedKey();

    Object.keys(localStorage).forEach((key) => {
      const isOldState =
        key === 'pfk_select_meals_state_v1' ||
        key.startsWith('pfk_select_meals_state_v2_');

      const isOldSubmitted =
        key === 'pfk_select_meals_submitted_v1' ||
        key.startsWith('pfk_select_meals_submitted_v2_');

      if (isOldState && key !== currentStateKey) {
        localStorage.removeItem(key);
      }

      if (isOldSubmitted && key !== currentSubmittedKey) {
        localStorage.removeItem(key);
      }
    });
  } catch (e) {}
}

  function serializeSelectionState() {
    return {
      state: JSON.parse(JSON.stringify(state)),
      addonState: JSON.parse(JSON.stringify(addonState))
    };
  }

  function saveSelectionToLocal() {
    if (!isSelectionPage) return;
    try {
      localStorage.setItem(getSelectionStorageKey(), JSON.stringify(serializeSelectionState()));
    } catch (e) {}
  }

  function loadSelectionFromLocal() {
    if (!isSelectionPage) return;
    try {
      const raw = localStorage.getItem(getSelectionStorageKey());
      if (!raw) return;

      const parsed = JSON.parse(raw);
      const savedMeals = parsed && parsed.state ? parsed.state : {};
      const savedAddons = parsed && parsed.addonState ? parsed.addonState : {};

      Object.keys(state).forEach(k => delete state[k]);
      Object.keys(addonState).forEach(k => delete addonState[k]);

      Object.keys(savedMeals).forEach((k) => {
        state[k] = savedMeals[k];
      });

      Object.keys(savedAddons).forEach((k) => {
        addonState[k] = savedAddons[k];
      });
    } catch (e) {}
  }

  function clearSelectionFromLocal() {
    if (!isSelectionPage) return;
    try {
      localStorage.removeItem(getSelectionStorageKey());
    } catch (e) {}
  }

    function markSelectionSubmitted() {
    if (!isSelectionPage) return;
    try {
      localStorage.setItem(getSelectionSubmittedKey(), '1');
    } catch (e) {}
  }

  function isSelectionSubmitted() {
    if (!isSelectionPage) return false;
    try {
      return localStorage.getItem(getSelectionSubmittedKey()) === '1';
    } catch (e) {
      return false;
    }
  }

  function clearSelectionSubmitted() {
    if (!isSelectionPage) return;
    try {
      localStorage.removeItem(getSelectionSubmittedKey());
    } catch (e) {}
  }

  const getAddonQty = (name) => addonState[name] || 0;
  const setAddonQty = (name, qty) => { addonState[name] = Math.max(0, Number(qty || 0)); };

  function getItem(cardOrId, maybeTitle) {
    const id = typeof cardOrId === 'string' ? cardOrId : (cardOrId.dataset.mealId || '');
    const title = maybeTitle || (typeof cardOrId === 'object' ? cardOrId.dataset.mealTitle : '') || '';
    if (!id) return null;
    if (!state[id]) state[id] = { title: title, portions: [] };
    if (title) state[id].title = title;
    if (!Array.isArray(state[id].portions)) state[id].portions = [];
    return state[id];
  }

  function totalSelected() {
    return Object.values(state).reduce((a, it) => a + (it.portions ? it.portions.length : 0), 0);
  }

  // ===========================
  // Parsing helpers
  // ===========================
  const optionsCache = new WeakMap();

  function decodeHtmlEntities(str) {
    const ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  function parseOptions(card) {
    if (optionsCache.has(card)) return optionsCache.get(card);
    const script = card.querySelector('.js-portion-options');
    const raw = script ? (script.textContent || '') : '';
    const decoded = decodeHtmlEntities(String(raw));
    const list = decoded.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    optionsCache.set(card, list);
    return list;
  }

  function parseListFromScript(el) {
    const raw = el ? (el.textContent || '').trim() : '';
    if (!raw) return [];
    if (/\r?\n/.test(raw)) return raw.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    if (raw.includes(',')) return raw.split(',').map(s => s.trim()).filter(Boolean);
    return [raw];
  }

  // ===========================
  // Popover close
  // ===========================
  function closeAllPopovers() {
    root.querySelectorAll('.ing-pop.is-open').forEach(p => p.classList.remove('is-open'));
    root.querySelectorAll('.detail-pop.is-open').forEach(p => p.classList.remove('is-open'));
    root.querySelectorAll('.addon-ing-pop.is-open').forEach(p => p.classList.remove('is-open'));
    root.querySelectorAll('.addon-detail-pop.is-open').forEach(p => p.classList.remove('is-open'));
    root.querySelectorAll('.addon-zoom-pop.is-open').forEach(p => p.classList.remove('is-open'));
  }

  if (!root.dataset.pfkGlobalCloseBound) {
    root.dataset.pfkGlobalCloseBound = '1';
    document.addEventListener('pointerdown', () => closeAllPopovers(), { passive: true });
    window.addEventListener('scroll', () => closeAllPopovers(), { passive: true });
  }

  // ===========================
  // Render Portions
  // ===========================
  function renderPortions(card) {
    const id = card.dataset.mealId;
    const title = card.dataset.mealTitle;
    const wrap = card.querySelector('.meal-portions');
    if (!wrap) return;

    const item = getItem(id, title);
    if (!item) return;

    const options = parseOptions(card);
    const portions = item.portions;

    wrap.innerHTML = '';
    if (portions.length === 0) return;

    portions.forEach((p, idx) => {
      const row = document.createElement('div');
      row.className = 'portion-row';

      if (options.length === 0) {
        row.innerHTML = `
          <div class="portion-label">Portion ${idx + 1}</div>
          <div class="portion-static">Included</div>
        `;
        wrap.appendChild(row);
        return;
      }

      row.innerHTML = `
        <div class="portion-label">Portion ${idx + 1}</div>
        <select class="portion-select" data-idx="${idx}"></select>
      `;

      const sel = row.querySelector('select');
      options.forEach((opt) => {
        const o = document.createElement('option');
        o.value = opt;
        o.textContent = opt;
        sel.appendChild(o);
      });

      const current = (p && p.option) ? p.option : options[0];
      sel.value = current;

      wrap.appendChild(row);
    });
  }

  function setCardCountUI(card) {
    const id = card.dataset.mealId;
    const qtyEl = card.querySelector('.meal-qty');
    const portions = (state[id] && state[id].portions) ? state[id].portions : [];
    if (qtyEl) qtyEl.textContent = String(portions.length);
    renderPortions(card);
  }

  // ===========================
  // Add-ons cents sum
  // ===========================
  function addonsSumCents() {
    const rows = Array.from(root.querySelectorAll('.addon-row'));
    return rows.reduce((sum, row) => {
      const name = row.dataset.addon;
      const qty = getAddonQty(name);
      const priceCents = getAddonPriceCents(row);
      return sum + priceCents * qty;
    }, 0);
  }

  // ===========================
  // Price UI
  // ===========================
  function updatePriceUI() {
    if (!priceOneEl) return;

    const hasPlan = !!sellingPlanId;
    const wantSub = isSubscriptionSelected();

    priceOneEl.style.display = '';
    priceOneEl.classList.toggle('is-strike', hasPlan && wantSub);

    if (!hasPlan) {
      if (priceSubEl) priceSubEl.style.display = 'none';
      if (priceBadgeEl) priceBadgeEl.style.display = 'none';
      return;
    }

    const subCents = (subPriceOverride > 0)
      ? Math.round(subPriceOverride * 100) * required
      : applyPercentOffCents(baseCents, SUB_PERCENT_OFF);

    if (priceSubEl) {
      priceSubEl.textContent = wantSub ? moneyFromCents(subCents) : '';
      priceSubEl.style.display = wantSub ? '' : 'none';
    }

    if (priceBadgeEl) {
      const memberLine = `🔓 Member price ${moneyFromCents(subCents)} • Only $${subPriceOverride.toFixed(2)} per meal`;
      const unlockLine = `🔒 Unlock member pricing — 👇select Subscribe & Save below`;

      priceBadgeEl.innerHTML = wantSub ? memberLine : unlockLine;
      priceBadgeEl.style.display = hasPlan ? '' : 'none';
    }
  }

  function updateAddonPriceUI() {
    const rows = Array.from(root.querySelectorAll('.addon-row'));
    rows.forEach(row => {
      const oneEl = row.querySelector('.js-addon-price-one');
      const subEl = row.querySelector('.js-addon-price-sub');
      const badgeEl = row.querySelector('.js-addon-badge');
      if (!oneEl || !subEl || !badgeEl) return;

      oneEl.classList.remove('is-strike');
      subEl.style.display = 'none';
      badgeEl.style.display = 'none';
    });
  }

  // ===========================
  // Meals bump
  // ===========================
  function bump(card, delta) {
    if (required <= 0) {
      if (msgEl) msgEl.textContent = 'Set bundle.required_qty first.';
      return;
    }
    if (msgEl) msgEl.textContent = '';

    const id = card.dataset.mealId;
    const title = card.dataset.mealTitle;
    const item = getItem(id, title);
    if (!item) return;

    const portions = item.portions;
    const total = totalSelected();
    const options = parseOptions(card);

    if (delta > 0) {
      if (total >= required) return;
      portions.push({ option: options.length ? options[0] : null });
    } else if (delta < 0) {
      portions.pop();
      if (portions.length === 0) delete state[id];
    }

    setCardCountUI(card);
    saveSelectionToLocal();
    scheduleStatus();
  }

  function initMealsUI() {
    cards.forEach(card => {
      const plus = card.querySelector('.qty-btn.plus');
      const minus = card.querySelector('.qty-btn.minus');
      bindTap(plus, () => bump(card, +1));
      bindTap(minus, () => bump(card, -1));
      setCardCountUI(card);
    });
  }

  function initAddonUI() {
    const rows = Array.from(root.querySelectorAll('.addon-row'));
    rows.forEach(row => {
      const name = row.dataset.addon;
      const minus = row.querySelector('.addon-minus');
      const plus = row.querySelector('.addon-plus');
      const count = row.querySelector('.addon-count');

      if (count) count.textContent = String(getAddonQty(name));

      bindTap(plus, () => {
        setAddonQty(name, getAddonQty(name) + 1);
        if (count) count.textContent = String(getAddonQty(name));
        saveSelectionToLocal();
        scheduleStatus();
      });

      bindTap(minus, () => {
        setAddonQty(name, getAddonQty(name) - 1);
        if (count) count.textContent = String(getAddonQty(name));
        saveSelectionToLocal();
        scheduleStatus();
      });
    });
  }

  function initAddonSizePickerUI() {
    const pickers = Array.from(root.querySelectorAll('.addon-size-picker'));

    pickers.forEach(picker => {
      const buttons = Array.from(picker.querySelectorAll('.addon-size-btn'));
      const row = picker.closest('.addon-row');
      if (!row || !buttons.length) return;

      buttons.forEach(btn => {
        if (btn.dataset.pfkSizeBound === '1') return;
        btn.dataset.pfkSizeBound = '1';

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const addonName = row.dataset.addon;
          const currentVariantId = String(row.dataset.variantId || '');
          const nextVariantId = String(btn.dataset.variantId || '');
          const countEl = row.querySelector('.addon-count');
          const currentQty = getAddonQty(addonName);

          const isChangingVariant =
            currentVariantId &&
            nextVariantId &&
            currentVariantId !== nextVariantId;

          if (isChangingVariant && currentQty > 0) {
            setAddonQty(addonName, 0);
            if (countEl) countEl.textContent = '0';
          }

          buttons.forEach(b => {
            b.classList.remove('is-active');
            b.style.background = '#ffffff';
            b.style.color = '#111827';
            b.style.border = '1px solid #d1d5db';
          });

          btn.classList.add('is-active');
          btn.style.background = '#1b5930';
          btn.style.color = '#ffffff';
          btn.style.border = '1px solid #1b5930';

          row.dataset.variantId = btn.dataset.variantId;
          row.dataset.price = btn.dataset.price;
          row.dataset.priceCents = btn.dataset.priceCents;

          const priceEl = row.querySelector('.js-addon-price-one');
          if (priceEl) {
            priceEl.textContent =
              '+' +
              (Number(btn.dataset.priceCents) / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              });
          }

          const imgEl = row.querySelector('.addon-img');
          if (imgEl && btn.dataset.image) {
            imgEl.src = btn.dataset.image;
          }

          const zoomImgEl = row.querySelector('.addon-zoom-pop img');
          if (zoomImgEl && btn.dataset.image) {
            zoomImgEl.src = btn.dataset.image.replace(/width=\d+/, 'width=800');
          }

          updateAddonPriceUI();
          saveSelectionToLocal();
          scheduleStatus();
        }, { passive: false });
      });
    });
  }

  // ===========================
  // Status + CTA
  // ===========================
  let isAdding = false;

  function setLoadingUI(loading) {
    isAdding = loading;
    const text = loading ? 'Adding to cart…' : null;

    if (addBtn) {
      addBtn.disabled = loading;
      addBtn.classList.toggle('is-loading', loading);
      if (loading) addBtn.textContent = text;
    }
    if (sumCtaBtn) {
      sumCtaBtn.disabled = loading;
      sumCtaBtn.classList.toggle('is-loading', loading);
      if (loading) sumCtaBtn.textContent = text;
    }
  }

  let _statusPending = false;
  function scheduleStatus() {
    if (_statusPending) return;
    _statusPending = true;
    requestAnimationFrame(() => {
      _statusPending = false;
      renderStatus();
    });
  }

  function renderStatus() {


    
    const total = totalSelected();
    const remaining = Math.max(required - total, 0);
    const ready = (required > 0 && total === required);
    if (sumWrap && isMobile()) {
  const wasReady = sumWrap.dataset.ready === 'true';

  if (ready && !wasReady) {
    sumWrap.classList.add('is-open');
  }

  sumWrap.dataset.ready = ready ? 'true' : 'false';
  
}

if (sumWrap && isMobile()) {
  const isClosed = !sumWrap.classList.contains('is-open');

  if (ready && isClosed) {
    sumWrap.classList.add('pfk-attention');

    setTimeout(() => {
      sumWrap.classList.remove('pfk-attention');
    }, 900);
  }
}



    const isSelectionPageNow = window.location.pathname.indexOf('/pages/select-meals') !== -1;


const submittedAlready = isSelectionPageNow && isSelectionSubmitted();

    if (selectedCountEl) selectedCountEl.textContent = String(total);

    if (remainingTextEl) {
      if (ready) remainingTextEl.textContent = '(ready)';
      else if (total > 0 && required > 0) remainingTextEl.textContent = `(remaining ${remaining})`;
      else remainingTextEl.textContent = '';
    }

    const wantSub = isSubscriptionSelected();
    const hasPlan = !!sellingPlanId;

    const displayBaseCents = (wantSub && hasPlan)
      ? ((subPriceOverride > 0)
          ? Math.round(subPriceOverride * 100) * required
          : applyPercentOffCents(baseCents, SUB_PERCENT_OFF))
      : baseCents;

    const addSumCents = addonsSumCents();
    const grandCents = displayBaseCents + addSumCents;

    if (addonsTotalTitleEl) {
      addonsTotalTitleEl.textContent = addSumCents > 0 ? `(+ ${moneyFromCents(addSumCents)})` : '';
    }

    if (!isAdding) {
      const ctaMoney = moneyFromCents(grandCents);

      if (addBtn) {
        addBtn.disabled = !ready;
        addBtn.classList.toggle('ready', ready);

        if (isSelectionPageNow) {
          addBtn.textContent = ready
            ? 'Save meal selection'
            : (total > 0 ? `Almost there — select ${remaining} more` : `Select your ${required} meals`);
        } else {
          addBtn.textContent = ready
            ? `Add to cart — ${ctaMoney}`
            : (total > 0 ? `Almost there — select ${remaining} more` : `Build your meal box (${required} meals)`);
        }
      }

      if (sumCtaBtn) {
        sumCtaBtn.disabled = !ready;

        if (isSelectionPageNow) {
          if (ready) {
            sumCtaBtn.textContent = 'Review & save meals';
          } else if (total === 0) {
            sumCtaBtn.textContent = 'Start selecting meals';
          } else {
            sumCtaBtn.textContent = `Select ${remaining} more meals`;
          }
        } else {
          if (ready) {
            sumCtaBtn.textContent = `Add to cart — ${ctaMoney}`;
          } else if (total === 0) {
            sumCtaBtn.textContent = 'Start selecting meals';
          } else {
            sumCtaBtn.textContent = `Add ${remaining} more to checkout`;
          }
        }
      }
    }

    if (sumSelectedEl) sumSelectedEl.textContent = String(total);

    sumRemainingEls.forEach(el => {
      el.textContent = `(remaining ${remaining})`;
    });

    if (sumAddonsEl) sumAddonsEl.textContent = moneyFromCents(addSumCents);
    if (sumTotalEl) sumTotalEl.textContent = moneyFromCents(grandCents);

    if (sumNoteEl) {
      if (isSelectionPageNow) {
        if (ready) {
          sumNoteEl.textContent = '🎉 Your box is ready — save your selection';
        } else if (total > 0) {
          sumNoteEl.textContent = `Select ${remaining} more meal${remaining === 1 ? '' : 's'} to finish`;
        } else {
          sumNoteEl.textContent = 'Start selecting your meals';
        }
      } else {
        sumNoteEl.textContent = ready ? 'Ready to checkout 🎉' : 'Pick meals to unlock checkout';
      }
    }

    if (sumHelperEl) {
  if (isSelectionPageNow && submittedAlready) {
    const hasExtrasSelected = addSumCents > 0;

    sumHelperEl.textContent = hasExtrasSelected
      ? '✅ Your meals have already been submitted for this week. You can still check out extras separately before the cutoff.'
      : '✅ Your meals have already been submitted for this week.';
    sumHelperEl.classList.add('is-ready');
  } else if (isSelectionPageNow) {
    if (ready) {
      const hasExtrasSelected = addSumCents > 0;
      sumHelperEl.textContent = hasExtrasSelected
        ? '🎉 Your meals are ready to save. Extras on this page will still need separate checkout.'
        : '🎉 Your meals are ready to save. You can still add extras on this page if you want.';
      sumHelperEl.classList.add('is-ready');
    } else if (total > 0) {
      sumHelperEl.textContent = `Select ${remaining} more meal${remaining === 1 ? '' : 's'} to finish your selection`;
      sumHelperEl.classList.remove('is-ready');
    } else {
      sumHelperEl.textContent = 'Select meals to continue';
      sumHelperEl.classList.remove('is-ready');
    }
  } else {
    if (ready) {
      sumHelperEl.textContent = "✅ Your box is complete — you’re ready to checkout. Our popular Extras are just below if you’d like to add a little more.";
      sumHelperEl.classList.add('is-ready');
    } else if (total > 0) {
      sumHelperEl.textContent = `Select ${remaining} more meal${remaining === 1 ? '' : 's'} to continue`;
      sumHelperEl.classList.remove('is-ready');
    } else {
      sumHelperEl.textContent = 'Select meals to continue';
      sumHelperEl.classList.remove('is-ready');
    }
  }
}
  }

  // ===========================
  // Clear
  // ===========================
  function clearAll() {
    Object.keys(state).forEach(k => delete state[k]);
    cards.forEach(card => setCardCountUI(card));

    Array.from(root.querySelectorAll('.addon-row')).forEach(row => {
      setAddonQty(row.dataset.addon, 0);
    });
    root.querySelectorAll('.addon-row .addon-count').forEach(el => el.textContent = '0');

    if (msgEl) msgEl.textContent = '';
    clearSelectionFromLocal();
    clearSelectionSubmitted();
    closeAllPopovers();
    updatePriceUI();
    updateAddonPriceUI();
    scheduleStatus();
  }

  // ===========================
  // Cart add
  // ===========================
  async function addLineItem(payload) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(await res.text());
  }

  function nowChicago() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function buildOrderProperties(total) {
    const props = {};
    const deliveryDate = window.PFKDelivery.getNextDeliveryDate();
    props['🚚 DELIVERY'] = formatDate(deliveryDate);
props['⏰ ORDER BY'] = window.PFKDelivery.getCutoffLabel();
    props['Total portions'] = String(total);
    props['Purchase'] = isSubscriptionSelected() ? 'Subscription' : 'One-time';

    let i = 1;
    Object.entries(state).forEach(([id, it]) => {
      const title = it.title || id;
      const portions = it.portions || [];
      portions.forEach((p) => {
        const opt = (p && p.option) ? ` (${p.option})` : '';
        props[String(i)] = `${title}${opt}`;
        i++;
      });
    });

    let a = 1;
    Array.from(root.querySelectorAll('.addon-row')).forEach((row) => {
      const name = row.dataset.addon;
      const q = getAddonQty(name);

      if (q > 0) {
        const currentVariantId = String(row.dataset.variantId || '').trim();

        const matchedBtn = currentVariantId
          ? row.querySelector(`.addon-size-btn[data-variant-id="${currentVariantId}"]`)
          : null;

        const variantTitle = matchedBtn
          ? String(matchedBtn.dataset.variantTitle || '').trim()
          : '';

        const sizeText =
          variantTitle && variantTitle.toLowerCase() !== 'default title'
            ? ` (${variantTitle})`
            : '';

        props[`Add-on ${a}`] = `${name}${sizeText} x${q}`;
        a++;
      }
    });

    return props;
  }

  async function handleAddToCart() {
    const btn = root.querySelector('.js-summary-cta');

    const total = totalSelected();
    if (!(required > 0 && total === required)) return;

    const isSelectionPageNow = window.location.pathname.indexOf('/pages/select-meals') !== -1;

    const submittedAlready = isSelectionPageNow && isSelectionSubmitted();

        if (isSelectionPageNow && isSelectionSubmitted()) {
  const addonRows = Array.from(root.querySelectorAll('.addon-row'));
  const hasExtrasSelected = addonRows.some((row) => {
    const name = row.dataset.addon;
    return getAddonQty(name) > 0;
  });

  if (!hasExtrasSelected) {
    if (msgEl) {
      msgEl.innerHTML = '';
      const box = document.createElement('div');
      box.style.whiteSpace = 'pre-line';
      box.style.marginTop = '10px';
      box.style.padding = '14px';
      box.style.border = '1px solid #dbe4ee';
      box.style.borderRadius = '12px';
      box.style.background = '#f8fbf9';
      box.style.color = '#1f2937';
      box.style.lineHeight = '1.6';
      box.textContent =
        '✅ You already submitted your meals for this week.\n\n' +
        'You can still order extras separately before the cutoff.';
      msgEl.appendChild(box);
    }
    return;
  }

      if (isAdding) return;
      setLoadingUI(true);

      try {
        for (const row of addonRows) {
          const name = row.dataset.addon;
          const vid = row.dataset.variantId;
          const qty = getAddonQty(name);
          if (!vid || qty <= 0) continue;

          const addonPayload = {
            id: Number(vid),
            quantity: qty,
            properties: { 'Added with': 'Separate extras checkout' }
          };

          await addLineItem(addonPayload);
        }

        window.location.assign('/checkout');
      } catch (e) {
        console.error(e);
        if (msgEl) msgEl.textContent = 'Could not start extras checkout. Please try again.';
        setLoadingUI(false);
        scheduleStatus();
      }
      return;
    }

        if (isSelectionPageNow) {
  const mealLines = [];
  const addonLines = [];

  Object.values(state).forEach((it) => {
    const title = it.title || 'Meal';
    const portions = Array.isArray(it.portions) ? it.portions : [];

    portions.forEach((p) => {
      const opt = p && p.option ? ` (${p.option})` : '';
      mealLines.push(`${title}${opt}`);
    });
  });

  Array.from(root.querySelectorAll('.addon-row')).forEach((row) => {
    const name = row.dataset.addon;
    const qty = getAddonQty(name);
    if (qty > 0) {
      const currentVariantId = String(row.dataset.variantId || '').trim();
      const matchedBtn = currentVariantId
        ? row.querySelector(`.addon-size-btn[data-variant-id="${currentVariantId}"]`)
        : null;

      const variantTitle = matchedBtn
        ? String(matchedBtn.dataset.variantTitle || '').trim()
        : '';

      const sizeText =
        variantTitle && variantTitle.toLowerCase() !== 'default title'
          ? ` (${variantTitle})`
          : '';

      addonLines.push(`${name}${sizeText} x${qty}`);
    }
  });

  const hasExtras = addonLines.length > 0;
  const deliveryDate = window.PFKDelivery.getNextDeliveryDate();
  const deliveryLabel = formatDate(deliveryDate);
  const customerEmailInput = document.querySelector('#PFKMealMailer-email');
const customerNameInput = document.querySelector('#PFKMealMailer-name');
const customerPhoneInput = document.querySelector('#PFKMealMailer-phone');
const customerBodyInput = document.querySelector('#PFKMealMailer-body');
const contactForm = document.querySelector('#PFKMealMailerForm');

  let summaryText = '';
  if (hasExtras) {
    summaryText =
      `🎉 Your meal selection has been submitted.\n\n` +
      `Delivery Date: ${deliveryLabel}\n` +
      `Purchase: Subscription\n\n` +
      `Meals selected:\n${mealLines.join('\n')}\n\n` +
      `Extras selected:\n${addonLines.join('\n')}\n\n` +
      `Extras are not included yet and require separate checkout.`;
  } else {
    summaryText =
      `🎉 Your meal selection has been submitted.\n\n` +
      `Delivery Date: ${deliveryLabel}\n` +
      `Purchase: Subscription\n\n` +
      `Meals selected:\n${mealLines.join('\n')}`;
  }

  if (contactForm && customerEmailInput && customerBodyInput) {
    customerEmailInput.value = (
      (window.Shopify && Shopify.customerEmail) ||
      customerEmailInput.value ||
      ''
    );

    if (customerNameInput) {
      customerNameInput.value =
        (window.Shopify && Shopify.customerName) ||
        customerNameInput.value ||
        'PureFuel customer';
    }

    if (customerPhoneInput && !customerPhoneInput.value) {
      customerPhoneInput.value = 'N/A';
    }

    customerBodyInput.value = summaryText;

    try {
      contactForm.requestSubmit();
    } catch (e) {
      contactForm.submit();
    }
  }

  if (msgEl) {
    msgEl.innerHTML = '';
    const box = document.createElement('div');
    box.style.whiteSpace = 'pre-line';
    box.style.marginTop = '10px';
    box.style.padding = '14px';
    box.style.border = '1px solid #dbe4ee';
    box.style.borderRadius = '12px';
    box.style.background = '#f8fbf9';
    box.style.color = '#1f2937';
    box.style.lineHeight = '1.6';
    box.textContent = summaryText;
    msgEl.appendChild(box);

    requestAnimationFrame(() => {
      const top = box.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      if (hasExtras && sumWrap) {
        sumWrap.classList.add('pfk-highlight');
        setTimeout(() => {
          sumWrap.classList.remove('pfk-highlight');
        }, 2200);
      }
    });
  }

  if (addBtn) {
    addBtn.textContent = 'Meal selection submitted';
    addBtn.disabled = true;
    addBtn.classList.remove('ready');
  }

  if (sumCtaBtn) {
    sumCtaBtn.textContent = hasExtras ? 'Checkout extras separately' : "You're all set 🎉";
    sumCtaBtn.disabled = !hasExtras;
  }

  if (sumNoteEl) {
    sumNoteEl.textContent = hasExtras
      ? 'Meal selection submitted. Extras require separate checkout. You can still update meals before the cutoff.'
      : '🎉 Meal selection submitted. No further action is needed right now. You can still update meals before the cutoff.';
  }

    if (sumHelperEl) {
    sumHelperEl.textContent = hasExtras
      ? '🎉 Your meals have been submitted. Extras still require separate checkout. You can still update your meals anytime before the cutoff.'
      : '🎉 Your meals have been submitted. You’re all set for this delivery. You can still update your meals anytime before the cutoff.';
    sumHelperEl.classList.add('is-ready');
  }

    const mealsText = mealLines.length ? mealLines.join('\n') : 'None';
  const extrasText = addonLines.length ? addonLines.join('\n') : 'None';

  const summaryTextForMake =
    `Customer: ${customerNameInput ? customerNameInput.value : ''}\n` +
    `Email: ${customerEmailInput ? customerEmailInput.value : ''}\n` +
    `Delivery Date: ${deliveryLabel}\n\n` +
    `Meals Selected:\n${mealsText}\n\n` +
    `Extras Selected:\n${extrasText}\n\n` +
    `Submitted At: ${new Date().toISOString()}`;

  fetch('https://hook.us2.make.com/gwsaxkx5o62icy5xmdiy7q6c43stv4j4', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      customer_name: customerNameInput ? customerNameInput.value : '',
      customer_email: customerEmailInput ? customerEmailInput.value : '',
      customer_phone: customerPhoneInput ? customerPhoneInput.value : '',
      delivery_date: deliveryLabel,
      meals: mealLines,
      extras: addonLines,
      meals_text: mealsText,
      extras_text: extrasText,
      summary_text: summaryTextForMake,
      submitted_at: new Date().toISOString()
    })
  });

  saveSelectionToLocal();
  clearSelectionFromLocal();
  markSelectionSubmitted();
  return;
}

    if (!variantId) { if (msgEl) msgEl.textContent = 'Bundle variant not found.'; return; }
    if (isAdding) return;

    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="pfk-spinner"></span>Adding to cart...';
    }

    setLoadingUI(true);

    try {
      if (msgEl) msgEl.textContent = 'Adding to cart…';

      const wantSub = isSubscriptionSelected();

      const bundlePayload = {
        id: Number(variantId),
        quantity: 1,
        properties: buildOrderProperties(total)
      };

      if (wantSub && sellingPlanId) {
        bundlePayload.selling_plan = Number(sellingPlanId);
      }

      await addLineItem(bundlePayload);

      const addonRows = Array.from(root.querySelectorAll('.addon-row'));
      for (const row of addonRows) {
        const name = row.dataset.addon;
        const vid = row.dataset.variantId;
        const qty = getAddonQty(name);
        if (!vid || qty <= 0) continue;

        const addonPayload = {
          id: Number(vid),
          quantity: qty,
          properties: { 'Added with': 'Meal plan add-on' }
        };

        await addLineItem(addonPayload);
      }

      if (btn) {
        btn.innerHTML = '✓ Added';
      }

      setTimeout(() => {
        window.location.assign('/cart');
      }, 500);
    } catch (e) {
      console.error(e);
      if (msgEl) msgEl.textContent = 'Could not add to cart. Please check availability/inventory.';
      setLoadingUI(false);
      scheduleStatus();
    }
  }

  // Portion select change
  root.addEventListener('change', (e) => {
    const sel = e.target.closest('.portion-select');
    if (!sel) return;
    const card = sel.closest('.meal-card');
    if (!card) return;

    const id = card.dataset.mealId;
    const title = card.dataset.mealTitle;
    const item = getItem(id, title);
    if (!item) return;

    const idx = parseInt(sel.dataset.idx || '0', 10);
    if (!item.portions[idx]) return;

    item.portions[idx].option = sel.value;
    saveSelectionToLocal();
  });

  // ===========================
  // Hover zoom (add-ons)
  // ===========================
  function initAddonHoverZoom() {
    const medias = Array.from(root.querySelectorAll('.addon-media'));

    function closeZoom() {
      root.querySelectorAll('.addon-zoom-pop').forEach(p => p.classList.remove('is-open'));
    }

    medias.forEach(media => {
      const row = media.closest('.addon-row');
      if (!row) return;
      if (row.querySelector('.addon-zoom-pop')) return;

      const img = media.querySelector('img');
      if (!img) return;

      const pop = document.createElement('div');
      pop.className = 'addon-zoom-pop';

      const big = document.createElement('img');
      big.src = (img.src || '').replace(/width=\d+/, 'width=800');
      big.alt = img.alt || '';

      pop.appendChild(big);
      row.appendChild(pop);

      if (!isTouch) {
        media.addEventListener('mouseenter', () => pop.classList.add('is-open'));
        media.addEventListener('mouseleave', () => pop.classList.remove('is-open'));
      } else {
        bindTap(media, () => {
          const open = pop.classList.contains('is-open');
          closeZoom();
          if (!open) pop.classList.add('is-open');
        });
      }
    });
  }

  // ===========================
  // Popovers
  // ===========================
  function initIngredientsPopover() {
    cards.forEach(card => {
      if (card.querySelector('.ing-btn')) return;

      const el = card.querySelector('.js-ingredients');
      const list = parseListFromScript(el);
      if (!list.length) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ing-btn';
      btn.textContent = 'Ingredients';

      const pop = document.createElement('div');
      pop.className = 'ing-pop';
      pop.innerHTML = `
        <div class="ing-title">Ingredients</div>
        <ul class="ing-list">${list.map(x => `<li>${x}</li>`).join('')}</ul>
      `;

      const actions = card.querySelector('.meal-actions');
      if (actions) actions.appendChild(btn);
      card.appendChild(pop);

      bindTap(btn, () => {
        const open = pop.classList.contains('is-open');
        closeAllPopovers();
        if (!open) pop.classList.add('is-open');
      });

      pop.addEventListener('pointerdown', (e) => e.stopPropagation(), { passive: true });
    });
  }

  function renderTextureDotsInline(level) {
    const v = (level || '').toString().trim().toLowerCase();
    let count = 1;
    if (v === 'medium') count = 2;
    if (v === 'firm') count = 3;

    let dots = '';
    for (let i = 1; i <= 3; i++) {
      dots += `<span class="dot ${i <= count ? 'filled' : ''}"></span>`;
    }
    return `<span class="dot-rating">${dots}</span>`;
  }

  function initDetailsPopover() {
    cards.forEach(card => {
      if (card.querySelector('.detail-btn')) return;

      const nutriScript = card.querySelector('.js-nutrition');
      const flavorScript = card.querySelector('.js-flavor');
      if (!nutriScript || !flavorScript) return;

      let nutri = {};
      let flavor = {};
      try { nutri = JSON.parse(nutriScript.textContent || '{}') || {}; } catch (e) {}
      try { flavor = JSON.parse(flavorScript.textContent || '{}') || {}; } catch (e) {}

      const notesEl = card.querySelector('.js-flavor-notes');
      const notes = parseListFromScript(notesEl);

      const hasAny =
        nutri.cal || nutri.pro || nutri.carb || nutri.fat ||
        (flavor && (flavor.spice || flavor.texture)) ||
        notes.length;

      if (!hasAny) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'detail-btn';
      btn.textContent = 'Details';

      const spice = (flavor.spice || '').toString().trim();
      const texture = (flavor.texture || '').toString().trim();

      const rows = [];
      if (nutri.cal != null && nutri.cal !== '') rows.push(`<div class="detail-row"><span>Calories</span><strong>${nutri.cal}</strong></div>`);
      if (nutri.pro != null && nutri.pro !== '') rows.push(`<div class="detail-row"><span>Protein</span><strong>${nutri.pro}g</strong></div>`);
      if (nutri.carb != null && nutri.carb !== '') rows.push(`<div class="detail-row"><span>Carbs</span><strong>${nutri.carb}g</strong></div>`);
      if (nutri.fat != null && nutri.fat !== '') rows.push(`<div class="detail-row"><span>Fat</span><strong>${nutri.fat}g</strong></div>`);

      const pop = document.createElement('div');
      pop.className = 'detail-pop';
      pop.innerHTML = `
        <div class="detail-title">Details</div>
        ${rows.length ? `<div class="detail-grid">${rows.join('')}</div>` : ''}

        ${(spice || texture) ? `
          <div class="detail-block">
            <div class="detail-sub">Spice & Texture</div>
            <div class="detail-line">
              ${spice ? `<div><span class="detail-label">Spice:</span> ${spice}</div>` : ``}
              ${texture ? `<div><span class="detail-label">Texture:</span> ${renderTextureDotsInline(texture)} <span class="detail-text">${texture}</span></div>` : ``}
            </div>
          </div>
        ` : ''}

        ${notes.length ? `
          <div class="detail-block">
            <div class="detail-sub">Flavor notes</div>
            <ul class="detail-list">${notes.map(x => `<li>${x}</li>`).join('')}</ul>
          </div>
        ` : ''}
      `;

      const actions = card.querySelector('.meal-actions');
      if (actions) actions.appendChild(btn);
      card.appendChild(pop);

      bindTap(btn, () => {
        const open = pop.classList.contains('is-open');
        closeAllPopovers();
        if (!open) pop.classList.add('is-open');
      });

      pop.addEventListener('pointerdown', (e) => e.stopPropagation(), { passive: true });
    });
  }

  function initAddonPopovers() {
    const rows = Array.from(root.querySelectorAll('.addon-row'));
    if (!rows.length) return;

    rows.forEach(row => {
      let actions = row.querySelector('.addon-actions');
      if (!actions) return;

      if (!row.querySelector('.addon-ing-btn')) {
        const elIng = row.querySelector('.js-addon-ingredients');
        const ingList = parseListFromScript(elIng);

        if (ingList.length) {
          const ingBtn = document.createElement('button');
          ingBtn.type = 'button';
          ingBtn.className = 'addon-ing-btn';
          ingBtn.textContent = 'Ingredients';
          actions.appendChild(ingBtn);

          const ingPop = document.createElement('div');
          ingPop.className = 'addon-ing-pop';
          ingPop.innerHTML = `
            <div class="addon-ing-title">Ingredients</div>
            <ul class="addon-ing-list">${ingList.map(x => `<li>${x}</li>`).join('')}</ul>
          `;
          row.appendChild(ingPop);

          bindTap(ingBtn, () => {
            const open = ingPop.classList.contains('is-open');
            closeAllPopovers();
            if (!open) ingPop.classList.add('is-open');
          });

          ingPop.addEventListener('pointerdown', (e) => e.stopPropagation(), { passive: true });
        }
      }

      if (!row.querySelector('.addon-detail-btn')) {
        const detailBtn = document.createElement('button');
        detailBtn.type = 'button';
        detailBtn.className = 'addon-detail-btn';
        detailBtn.textContent = 'Details';
        actions.appendChild(detailBtn);

        const detailPop = document.createElement('div');
        detailPop.className = 'addon-detail-pop';

        let d = {};
        const s = row.querySelector('.js-addon-details');
        try { d = JSON.parse((s && s.textContent) ? s.textContent : '{}') || {}; } catch (e) { d = {}; }

        const cal = (d.cal != null && d.cal !== '') ? `${d.cal}` : '—';
        const pro = (d.pro != null && d.pro !== '') ? `${d.pro}g` : '—';
        const carb = (d.carb != null && d.carb !== '') ? `${d.carb}g` : '—';
        const fat = (d.fat != null && d.fat !== '') ? `${d.fat}g` : '—';

        const spice = (d.spice || '—');
        const texture = (d.texture || '');
        const notesEl = row.querySelector('.js-addon-notes');
        const notes = parseListFromScript(notesEl);

        detailPop.innerHTML = `
          <div class="detail-title">Details</div>
          <div class="detail-grid">
            <div class="detail-row"><span>Calories</span><strong>${cal}</strong></div>
            <div class="detail-row"><span>Protein</span><strong>${pro}</strong></div>
            <div class="detail-row"><span>Carbs</span><strong>${carb}</strong></div>
            <div class="detail-row"><span>Fat</span><strong>${fat}</strong></div>
          </div>
          <div class="detail-block">
            <div class="detail-sub">Spice & Texture</div>
            <div class="detail-line">
              <div><span class="detail-label">Spice:</span> ${spice}</div>
              <div><span class="detail-label">Texture:</span> ${texture ? `${renderTextureDotsInline(texture)} <span class="detail-text">${texture}</span>` : '—'}</div>
            </div>
          </div>
          ${notes.length ? `
            <div class="detail-block">
              <div class="detail-sub">Flavor notes</div>
              <ul class="detail-list">${notes.map(x => `<li>${x}</li>`).join('')}</ul>
            </div>
          ` : ``}
        `;
        row.appendChild(detailPop);

        bindTap(detailBtn, () => {
          const open = detailPop.classList.contains('is-open');
          closeAllPopovers();
          if (!open) detailPop.classList.add('is-open');
        });

        detailPop.addEventListener('pointerdown', (e) => e.stopPropagation(), { passive: true });
      }
    });
  }

  // ===========================
  // Summary collapse (mobile only)
  // ===========================
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function toggleSummary() {
    if (!sumWrap) return;
    if (!isMobile()) return;
    sumWrap.classList.toggle('is-open');

    if (sumToggleBtn) {
      const open = sumWrap.classList.contains('is-open');
      sumToggleBtn.textContent = open ? '▴' : '▾';
      sumToggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  if (sumTitle) {
  bindTap(sumTitle, toggleSummary);
}

if (sumToggleBtn) {
  bindTap(sumToggleBtn, (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }

    toggleSummary();
    suppressNextGhostClick(350);
  });
}

if (sumWrap) {
  bindTap(sumWrap, (e) => {
    if (!isMobile()) return;

    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }

    const clickedInsideBody = e.target.closest('.pfk-sum-body');
    const clickedCta = e.target.closest('.js-summary-cta');
    const clickedClear = e.target.closest('.js-clear');
    const clickedToggle = e.target.closest('.pfk-sum-toggle');

    if (clickedInsideBody || clickedCta || clickedClear || clickedToggle) return;

    toggleSummary();
  });
}

  // ===========================
  // Events
  // ===========================
  clearBtns.forEach(btn => bindTap(btn, clearAll));
  bindTap(addBtn, handleAddToCart);
  bindTap(sumCtaBtn, handleAddToCart);

  window.addEventListener('pageshow', () => {
  setLoadingUI(false);
  scheduleStatus();
});

  // ===========================
  // Init
  // ===========================
  cleanupOldSelectionStorage();
  loadSelectionFromLocal();

  initMealsUI();
  initAddonUI();
  initAddonSizePickerUI();
  initAddonHoverZoom();
  initIngredientsPopover();
  initDetailsPopover();
  initAddonPopovers();

  cards.forEach(card => setCardCountUI(card));
  root.querySelectorAll('.addon-row').forEach(row => {
    const name = row.dataset.addon;
    const count = row.querySelector('.addon-count');
    if (count) count.textContent = String(getAddonQty(name));
  });

  updatePriceUI();
  updateAddonPriceUI();
  renderStatus();
  scheduleStatus();

})();



const MOBILE_CATEGORY_MODE = 'all-open';
// 可选值：
// 'all-open'   = 手机端全部展开
// 'all-closed' = 手机端全部收起
// 'first-open' = 手机端只展开第一个

function setCategoryOpen() {
  const cats = document.querySelectorAll('.pfk-category-section');

  if (window.innerWidth < 768) {
    if (MOBILE_CATEGORY_MODE === 'all-open') {
      cats.forEach(el => el.setAttribute('open', ''));
    } else if (MOBILE_CATEGORY_MODE === 'first-open') {
      cats.forEach((el, index) => {
        if (index === 0) {
          el.setAttribute('open', '');
        } else {
          el.removeAttribute('open');
        }
      });
    } else {
      cats.forEach(el => el.removeAttribute('open'));
    }
  } else {
    cats.forEach(el => el.setAttribute('open', ''));
  }
}

document.addEventListener('DOMContentLoaded', setCategoryOpen);



function injectCategoryHints() {
  const cats = document.querySelectorAll('.pfk-category-section');

  cats.forEach((section) => {
    if (section.previousElementSibling?.classList?.contains('pfk-category-hint')) return;

    const hint = document.createElement('div');
    hint.className = 'pfk-category-hint';
    hint.textContent = 'Tap below to select your meals👇';

    section.parentNode.insertBefore(hint, section);
  });
}

document.addEventListener('DOMContentLoaded', injectCategoryHints);